import { z } from 'zod';

const membershipDocumentsReturnPattern =
  /^\/(en|ru)\/crm\/memberships\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?:\?[^#]*)?$/iu;

/** Only the currently rendered profile tabs are canonical URL state. */
export const documentProfileSearchSchema = z.object({
  documentTab: z.enum(['file']).optional(),
  edit: z.boolean().optional().catch(undefined),
  learningRegistrationId: z.uuid().optional().catch(undefined),
  membershipReturnTo: z
    .string()
    .max(4096)
    .regex(membershipDocumentsReturnPattern)
    .optional()
    .catch(undefined),
});

export type DocumentProfileSearch = z.infer<typeof documentProfileSearchSchema>;

export function normalizeDocumentProfileSearch(
  search: Record<string, unknown>
): DocumentProfileSearch {
  return documentProfileSearchSchema.parse({
    ...search,
    documentTab: search.documentTab === 'audit' ? undefined : search.documentTab,
  });
}
